import { DataWarehouseDataService } from "../../DataService/DataWarehouseDataService";
import { Toastr } from "../../Helpers/Toastr";
import { AddOrUpdateDocComment } from "../../Models/DataWarehouse/AddOrUpdateDocComment";

export class AddOrUpdateCommentManager {

    constructor(private containerElement: JQuery) { }

    private commentsTable : JQuery<HTMLElement>;
    private commentsTableBody : JQuery<HTMLElement>;
    private addCommentButton : JQuery<HTMLElement>;

    private docDetailCommentField : JQuery<HTMLElement>;

    private templateElement : JQuery<HTMLElement>;

    private docRevisionId;
    private docHeaderId;
    private lineItemId;

    public initialize(docHeaderId : string, docRevisionId : string, lineItemId: string | undefined = undefined) {
        this.docHeaderId = docHeaderId;
        this.docRevisionId = docRevisionId;
        this.lineItemId = lineItemId;

        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        this.commentsTable = this.containerElement.find('#comments-table');

        this.commentsTableBody = this.commentsTable.find('tbody');
        this.addCommentButton = this.containerElement.find('#add-comment-button');

        this.templateElement = this.containerElement.find('#templates-comment-row');


        this.docDetailCommentField = this.containerElement.find('#doc-detail-comment-field');

        console.log(self.lineItemId);
    }

    private bindEvents() {
        var self = this;

        if(self.docDetailCommentField != undefined && self.docDetailCommentField.length > 0) {
            self.docDetailCommentField.off('change').on('change', () => {

                var addOrUpdateModel = new AddOrUpdateDocComment();
                addOrUpdateModel.lineItemId = self.lineItemId;
                addOrUpdateModel.value = self.docDetailCommentField.val()!.toString();

                DataWarehouseDataService.addOrUpdateComment(self.docHeaderId, self.docRevisionId, addOrUpdateModel, (commentId) => {

                });
            })
        }
        else {
            self.addCommentButton.off('click').on('click', () => {
                self.addCommentButton.prop('disabled', true);

                var addModel = new AddOrUpdateDocComment();
                addModel.lineItemId = self.lineItemId;
                addModel.value = 'Insert comment here...';

                DataWarehouseDataService.addOrUpdateComment(self.docHeaderId, self.docRevisionId, addModel, (commentId) => {
                    var newListItem = $(self.templateElement.html());

                    this.bindCommentRow(newListItem, commentId);
            
                    self.commentsTableBody.append(newListItem);
        
                    self.addCommentButton.prop('disabled', false);
                })
            });

            self.commentsTableBody.find('tr').each((index, element) => {
                var listItemRow = $(element);
                var commentId = listItemRow.data('comment-id');

                self.bindCommentRow(listItemRow, commentId);
            }) 
        }


    }

    private bindCommentRow(row : JQuery<Element>, commentId: string) {
        var self = this;

        var commentInput = row.find('#comment-input');
        commentInput.off('change').on('change', () => {

            var updateModel = new AddOrUpdateDocComment();
            updateModel.commentId = commentId;
            updateModel.lineItemId = self.lineItemId;

            var comment = commentInput.val();
            if(comment == undefined || comment.toString().length <= 0) {
                Toastr.Error('Comment is empty', `It's not allowed to leave the comment empty.`)
                return;
            }

            updateModel.value = comment.toString();

            DataWarehouseDataService.addOrUpdateComment(self.docHeaderId, self.docRevisionId, updateModel, (commentId) => {

            })
        })

        var removeButton = row.find('#remove-button');
        removeButton.off('click').on('click', () => {
            removeButton.prop('disabled', true);
            DataWarehouseDataService.deleteComment(self.docHeaderId, self.docRevisionId, commentId, (result) => {
                if(result) {
                    row.remove();
                }
                else {
                    Toastr.Error(`Couldn't delete comment`, `Due to an error we couldn't delete the comment. Please try again later`);
                    removeButton.prop('disabled', false);
                }
            })
        });

    }

}